var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 36,
    viewBox: "0 0 14 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#909ca8",
    d: "M13 4v12c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V4zm1-1H0V1h3.5l1-1h5l1 1H14z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBucket);
export default __webpack_public_path__ + "static/media/bucket.080b93f66dba150e9a7fc3b230cf42cc.svg";
export { ForwardRef as ReactComponent };